import { render } from "./tw-textarea.vue?vue&type=template&id=5d32efc2"
import script from "./tw-textarea.vue?vue&type=script&lang=js"
export * from "./tw-textarea.vue?vue&type=script&lang=js"
script.render = render

export default script